// import "./Resume.css";
import Navbar from "../components/Navbar";
import { useEffect, useRef, useState, useCallback } from "react";
import { motion } from "framer-motion";

import { useSelector, useDispatch } from "react-redux";
import {
  setCursorStyle,
  updateCursorPosition,
} from "../features/cursor/cursorSlice";

import AOS from "aos";
import "aos/dist/aos.css";

import returnCursorVariant from "../resources/cursorStyles.js";
import ScrollToTop from "../components/ScrollToTop";
import FullScreenNav from "../components/FullScreenNav";

import Vara from "vara";
import { Helmet } from "react-helmet-async";
import "./LearnMore.css";
import "../App.css";

const LearnMore = (props) => {
  const curVar = useSelector((state) => state.cursor.cursorVariant);
  const curPosition = useSelector((state) => state.cursor.cursorPosition);
  const dispatch = useDispatch();

  const [showFullScreenNav, setShowFullScreenNav] = useState(false);
  const handleProjectsClick = (e) => {
    e.preventDefault();
    setShowFullScreenNav(true);
  };

  const bulletData = [
    {
      category: "Work Experience",
      company: "BuildSmartr Inc.",
      companyHyperlink: "https://buildsmartr.com/",
      bullets: [
        "Built and published a cross-platform React Native RAG app on Apple & Google stores, enabling crews to query AI trained on construction site documents, improving on-site query resolution operational responsiveness.",
        "Developed a B2B wall-ordering platform using Next.js that transformed fragmented email communication into a unified order management system, streamlining coordination and cutting response delays by over 65%.",
        "Revamped and deployed the company's portfolio platform with enhanced technical SEO, accessibility, and animation polish, optimizing CTAs and user flow to increase click-through rates and engagement by 43%.",
      ],
    },
    {
      category: "Work Experience",
      company: "Cornerstone International College",
      companyHyperlink: "https://ciccc.ca/wps-members/awshaf-ishtiaque/",
      bullets: [
        "Developed and instructed a comprehensive programming curriculum for over 40 students, spanning basic syntax to advanced full-stack development, incorporating key concepts like OOP and Big O Notation, which enhanced learning outcomes.",
        "Regularly updated and validated educational content to include cutting-edge programming practices in JavaScript and TypeScript, ensuring course relevancy and student preparedness for modern tech environments.",
        "Enhanced student engagement and performance by implementing innovative online learning modules and leveraging data analytics, resulting in a 20% improvement in assessment scores.",
      ],
    },
    {
      category: "Work Experience",
      company: "Digitec Innovation",
      companyHyperlink: "https://www.digitecinnovation.ca/",
      bullets: [
        "Co-founded Digitec Innovation to provide custom-tailored web services, with a focus on client-centric development and market-driven solutions.",
        "Led the end-to-end development of feature requests, starting from the creation of RESTful APIs and culminating in frontend rendering, resulting in a 20% reduction in time-to-market for client requested features.",
        "Led the implementation of CI/CD pipeline shortening the development cycle and automated testing before merges.",
        "Efficiently managed client relationships using an agile-waterfall methods, to address evolving client needs resulting in higher client satisfaction & company recognition.",
      ],
    },
    {
      category: "Work Experience",
      company: "Wave Business Intelligence.",
      companyHyperlink: "https://www.wavebi.com.ar/",
      bullets: [
        "Upgraded legacy HTML/CSS/JavaScript pages to interactive Next.js web apps streamlining code reusability and enforcing a cohesive design framework, resulting in a notable 27% improvement in conversion rates.",
        "Implemented a dynamic caching solution that prioritized the efficient loading of high-bandwidth content, like images & videos, reducing resource load times by 15% offering an uninterrupted & rapid browsing experience.",
        "Utilized StorybookJS to extensively test and visualize React reusable components, their functionality & responsiveness across multiple devices and dimension, ensuring 100% bug-free deliverables.",
      ],
    },
    {
      category: "Work Experience",
      company: "Pangenomic Health Corp.",
      companyHyperlink: "https://www.pangenomic.com/",
      bullets: [
        "Integrated Strapi CMS to optimize content management workflows resulting in a 26% increase in editorial efficiency and content production velocity.",
        "Collaborated with the UI/UX team to gather specifications and developed the Feed screen using React-Native functional components, ensuring cross-platform functionality for both Android and iOS.",
        "Defined API endpoints in NodeJS backend to fetch data from Cloud PostgreSQL asynchronously and cache it locally to reduce page load times by 25% for the Feed & Settings screen.",
        "Built comprehensive API test plans, identifying critical bugs on emulators & mobile devices before production.",
      ],
    },
    {
      category: "Digitec Projects",
      company: "Fashion E-Boutique",
      companyHyperlink: "https://howuniversehowls.ca/",
      bullets: [
        "Lead the development of a robust e-commerce platform utilizing the PERN stack, facilitating seamless online purchases of t-shirts",
        "Integrate 3rd Party - Stripe, to accept all major payment methods in a secured transaction process to facilitate more customer trust",
        "Maintained transparent communication with clients to accommodate their feature requests and ensure client satisfaction",
      ],
    },
    {
      category: "Digitec Projects",
      company: "Prestigious Power Washing",
      companyHyperlink: "https://www.prestigiouspressure.ca/",
      bullets: [
        "Orchestrate the development of the company portfolio website from its legacy existing Wix website",
        "Apply SEO techniques to increase customer retention rate by 35%.",
      ],
    },
    {
      category: "Digitec Projects",
      company: "Rudolph Christmas Lights",
      companyHyperlink: "https://www.rudolphchristmaslights.ca/",
      bullets: [
        "Designed and developed a visually stunning Next.js website for Rudolph Christmas Lights, incorporating immersive parallax scrolling animations to enhance user engagement. The site features dynamic content sections that react to user scrolling, creating a memorable browsing experience tailored for the festive season.",
        "SERP managed, Google Analytics, semantic html and many more techniques to bring the website in the first 10 Google search resutls.",
      ],
    },
    {
      category: "Digitec Projects",
      company: "Clipping Path Service ASIA",
      companyHyperlink: "https://www.clippingpathserviceasia.com/",
      bullets: [
        "Built responsive, reusable components in NextJS using props and modularized CSS facilitating their utilization across multiple pages enhancing code reusability & time to deploy new webpages by 30%.",
        "Implemented a secure NodeMailer API endpoint within server-side Next.js components for secured email transmission with large attachments, facilitating seamless communication and better user experience.",
      ],
    },
  ];

  // eslint-disable-next-line
  const [currentUrl, setCurrentUrl] = useState("");

  const doodleSectionRef = useRef(null);
  const [doodleSectionInView, setDoodleSectionInView] = useState(false);

  // eslint-disable-next-line
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const isPhoneWidth = screenWidth <= 600;
  const fontsizing = Math.round(
    Math.min(38, Math.max(14, screenWidth / (isPhoneWidth ? 20 : 28)))
  );
  const pitch = Math.round(fontsizing * 2.2);
  const varaStartedRef = useRef(false);

  const initializeVara = useCallback(() => {
    let currentDate = new Date().toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    currentDate = currentDate.replace(",", "");

    const lines = isPhoneWidth
      ? [
          { text: `Today is ${currentDate},`, duration: 950, delay: 550 },
          { text: `On this date, you explored`, duration: 900, delay: 350 },
          { text: `my page and delved into`, duration: 850, delay: 150 },
          { text: `the narrative I've crafted.`, duration: 900, delay: 150 },
          { text: `I hope you found this`, duration: 800, delay: 350 },
          { text: `digital journey engaging.`, duration: 850, delay: 150 },
          { text: `Feel free to shoot me a`, duration: 850, delay: 350 },
          { text: `message on LinkedIn or email`, duration: 950, delay: 150 },
          { text: `to let me know your thoughts!`, duration: 950, delay: 150 },
          { text: `Yours truly,`, duration: 600, delay: 450 },
          { text: `Awshaf Ishtiaque`, duration: 1500, delay: 400, strokeWidth: 1.8 },
        ]
      : [
          { text: `Today is ${currentDate},`, duration: 1140, delay: 550 },
          { text: `On this date, you explored my page`, duration: 1370, delay: 490 },
          { text: `and delved into the narrative I've crafted.`, duration: 1370, delay: 200 },
          { text: `I hope you found this digital journey engaging.`, duration: 1500, delay: 590 },
          { text: `Feel free to shoot me a message on LinkedIn`, duration: 1430, delay: 590 },
          { text: `or email to let me know your thoughts!`, duration: 1300, delay: 200 },
          { text: `Yours truly,`, duration: 880, delay: 520 },
          { text: `Awshaf Ishtiaque`, duration: 1890, delay: 460, strokeWidth: 1.8 },
        ];

    const vara = new Vara(
      "#myVaraText",
      "https://raw.githubusercontent.com/akzhy/Vara/master/fonts/Satisfy/SatisfySL.json",
      lines.map((line, index) => ({
        id: `line${index + 1}`,
        text: line.text,
        fontSize: fontsizing,
        strokeWidth: line.strokeWidth || 1,
        color: "black",
        duration: line.duration,
        textAlign: "left",
        x: 10,
        y: Math.round((index + 1) * pitch - 0.8 * fontsizing),
        fromCurrentPosition: { x: true, y: false },
        lineHeight: pitch,
        autoAnimation: true,
        queued: true,
        delay: line.delay,
        letterSpacing: 0,
      }))
    );
    vara.ready();
  }, [fontsizing, pitch, isPhoneWidth]);

  useEffect(() => {
    const mouseMove = (e) => {
      dispatch(
        updateCursorPosition({
          x: e.clientX,
          y: e.clientY,
        })
      );
    };
    window.addEventListener("mousemove", mouseMove);
    AOS.init({
      offset: 30,
      duration: 500,
      easing: "ease-in-sine",
      once: true,
      mirror: false,
      delay: 25,
    });
    AOS.refresh();
    setCurrentUrl(window.location.href);

    // for DoodleSection:
    const handleScroll = () => {
      const { top } = doodleSectionRef.current.getBoundingClientRect();
      if (top >= -403 && top <= window.innerHeight * 0.8) {
        setDoodleSectionInView(true);
        dispatch(setCursorStyle("modalEnter"));
      } else if (top <= -441) {
        dispatch(setCursorStyle("hideCursor"));
      } else {
        setDoodleSectionInView(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("mousemove", mouseMove);
      window.removeEventListener("scroll", handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (doodleSectionInView && !varaStartedRef.current) {
      varaStartedRef.current = true;
      initializeVara();
    }
  }, [doodleSectionInView, initializeVara]);

  return (
    <div>
      <Helmet>
        <title>Learn More | Awshaf Ishtiaque</title>
        <meta
          name="description"
          content="Learn more about my journey as a Web Developer, Instructor at CICCC, and Co-Founder of Digitec Innovation and his educational background."
        />
        <meta
          name="keywords"
          content="Learn More, Awshaf, Web Developer, Instructor, CICCC, Digitec Innovation"
        />
        <link rel="canonical" href="https://awshaf.com/learnmore" />
        <meta property="og:title" content="Learn More | Awshaf Ishtiaque" />
        <meta
          property="og:description"
          content="Discover more about Awshaf's journey and expertise."
        />
        <meta property="og:url" content="https://awshaf.com/learnmore" />
        <meta property="og:type" content="website" />
      </Helmet>

      {/* DOODLE SECTION */}
      <div className="doodleContainer">
        <section
          className={`LMrodalSection ${
            doodleSectionInView ? "doodleFSactive" : ""
          }`}
          style={{
            backgroundImage: `repeating-linear-gradient(#FEF4D4 0px, #FEF4D4 ${
              pitch - 1
            }px, teal ${pitch}px)`,
            paddingTop: `${pitch}px`,
          }}
        >
          <div className="content" id="myVaraText"></div>
        </section>
      </div>

      <FullScreenNav
        showFullScreenNav={showFullScreenNav}
        setShowFullScreenNav={setShowFullScreenNav}
      ></FullScreenNav>

      <div className="bg container learnMoreParent">
        <ScrollToTop />

        {!doodleSectionInView && (
          <Navbar
            onClickHandler={() => handleProjectsClick()}
            setShowFullScreenNav={setShowFullScreenNav}
            showFullScreenNav={showFullScreenNav}
            textEnterLogo={() => dispatch(setCursorStyle("logo"))}
            textLeaveLogo={() => dispatch(setCursorStyle("default"))}
          ></Navbar>
        )}

        <motion.div
          className="cursor"
          variants={returnCursorVariant(curPosition)}
          animate={curVar}
        />

        {!showFullScreenNav && (
          <section
            className={`secondSection ${
              doodleSectionInView ? "doodleSectionStyles" : ""
            }`}
          >
            <div className="paraContainers globalTextStyles">
              <div className="bigRow">
                <h2 className="jobTitle">Work Experience</h2>
                {bulletData
                  .filter((item) => item.category === "Work Experience")
                  .map((singleBullet, index) => {
                    return (
                      <WorkExperienceItem
                        category={singleBullet.category}
                        key={singleBullet.company}
                        company={singleBullet.company}
                        companyHyperlink={singleBullet.companyHyperlink}
                        bullets={singleBullet.bullets}
                      />
                    );
                  })}
              </div>

              <div className="bigRow">
                <h2 className="jobTitle">Digitec Projects</h2>
                {bulletData
                  .filter((item) => item.category === "Digitec Projects")
                  .map((singleBullet, index) => {
                    return (
                      <WorkExperienceItem
                        category={singleBullet.category}
                        key={singleBullet.company}
                        company={singleBullet.company}
                        companyHyperlink={singleBullet.companyHyperlink}
                        bullets={singleBullet.bullets}
                      />
                    );
                  })}
              </div>

              {/* E D U C A T I O N */}
              <div className="bigRow">
                <h2 className="jobTitle">Education</h2>

                <div className="educationContainer">
                  <a
                    id="schoolName"
                    href="https://www.sfu.ca/"
                    className="company"
                    data-aos="zoom-out"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Simon Fraser University
                  </a>
                  <div className="sfulogo">
                    <img
                      className="logoicon"
                      src={require("../resources/sfulogo.png")}
                      alt="sfulogo"
                    ></img>
                  </div>
                </div>

                <div className="bulletContainer eduBullet">
                  <h3
                    className="bullet"
                    data-aos="zoom-out-left"
                    data-aos-offset={50}
                    onMouseEnter={() => dispatch(setCursorStyle("text"))}
                    onMouseLeave={() => dispatch(setCursorStyle("default"))}
                  >
                    BSC In Applied Science
                  </h3>
                  <h3
                    className="bullet"
                    data-aos="zoom-out-left"
                    data-aos-offset={100}
                    onMouseEnter={() => dispatch(setCursorStyle("text"))}
                    onMouseLeave={() => dispatch(setCursorStyle("default"))}
                  >
                    Major in Computer Science
                  </h3>
                </div>
              </div>
            </div>

            <div ref={doodleSectionRef} className="doodleSection">
              <p className="boldPara">My Doodle Section:</p>
            </div>
          </section>
        )}
      </div>
    </div>
  );
};

const WorkExperienceItem = ({
  company,
  companyHyperlink,
  bullets,
  category,
}) => {
  const dispatch = useDispatch();
  return (
    <div className="EachBulletObject ">
      <div className="parentBulletContainer">
        <div className="companyRow">
          <a
            href={companyHyperlink}
            className="company"
            // data-aos="zoom-out"
            target="_blank"
            rel="noopener noreferrer"
          >
            {company}
          </a>
        </div>

        <div className="bulletContainer">
          {bullets.map((bullet, index) => {
            const offset = 0 + index * 15;
            // const offset = 0;
            return (
              <li
                className="bullet"
                data-aos="zoom-out-left"
                data-aos-offset={offset}
                key={bullet}
                onMouseEnter={() => dispatch(setCursorStyle("text"))}
                onMouseLeave={() => dispatch(setCursorStyle("default"))}
              >
                {bullet}
              </li>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LearnMore;

/* TODO:
    - Different cursor effect based on each hoveredOn element
      -> on hovering over job experience, show its timeline
    - Transition Groups
*/
